// import { Loading } from 'element-ui';
import { validatenull } from '@/echart/util'
import { checkUrl, checkYzfcApi, checkVisualApi, getFunction } from '@/utils/utils'
import {getToken} from '@/utils/auth';
import website from '@/config/website';
import {Message} from 'element-ui';
import {Base64} from 'js-base64';
import axios from 'axios';
import store from '@/store/';
import router from './router';
import {
  getStore,
} from '@/utils/store'
window.$glob = {
  url: '',
  params: {},
  query: {},
  headers: {}
};
function getGlobParams () {
  var query = window.location.search.substring(1);
  query = query.split("&");
  query.forEach(ele => {
    var pair = ele.split("=");
    window.$glob.params[pair[0]] = pair[1]
  })
}

axios.defaults.timeout = 10000;
//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
// let loadingInstance = '';
axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
  // loadingInstance = Loading.service({
  //   text: '拼命加载中',
  //   background: 'rgba(0,0,0,0)',
  //   spinner: 'el-icon-loading'
  // });
  getGlobParams();
  if (!checkUrl(config.url)) {
    config.url = window.$glob.url + config.url;
  }
  if (!validatenull(window.$glob.header)) {
    let header = getFunction(window.$glob.header)();
    config.headers = Object.assign(config.headers, header);
  }
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;
  const isYzfcApi = checkYzfcApi(config.url);
  const isVisualApi = checkVisualApi(config.url);
  // console.log(config.url);
  // console.log('isYzfcApi = ' + isYzfcApi);
  // console.log('getToken() = ' + getToken());
  config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
  //让每个请求携带token
  if (getToken() && !isToken && (isYzfcApi || isVisualApi)) {
    config.headers[website.tokenHeader] = 'bearer ' + getToken()
  }
  // 业务接口统一带租户ID（登录/刷新等已自带 Tenant-Id 的不覆盖）
  if ((isYzfcApi || isVisualApi) && (config.headers['Tenant-Id'] === undefined || config.headers['Tenant-Id'] === '')) {
    const tenantId = store.state.user.tenantId || getStore({ name: 'tenantId' }) || website.tenantId || ''
    if (tenantId) config.headers['Tenant-Id'] = tenantId
  }
  const language=getStore({ name: 'language' })
  if(language=='en'){
    config.headers['Accept-Language']='en-US'
  }
  if(language=='zh'){
    config.headers['Accept-Language']='zh-CN'
  }
  //获取全局参数
  if (typeof (config.data) === 'object' && !validatenull(window.$glob.query)) {
    let query = getFunction(window.$glob.query)();
    let data = Object.assign(window.$glob.params, query)
    if (config.method == 'get') {
      config.params = Object.assign(config.params, data)
    } else if (config.method == 'post') {
      config.data = Object.assign(config.data, data)
    }
  }
  return config
}, error => {
  return Promise.reject(error)
});
//HTTPrequest拦截
axios.interceptors.response.use(res => {
  const status = res.data.code || res.status;
  const statusWhiteList = website.statusWhiteList || [];
  const message = res.data.msg || res.data.error_description || '未知错误';

  //如果在白名单里则自行catch逻辑处理
  // if (statusWhiteList.includes(status)) return Promise.reject(res);

  //如果是401则跳转到登录页面
  if (status === 401) {
    // store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
    const loginUrl = process.env.VUE_APP_ADMIN_LOGIN_URL || `${process.env.VUE_APP_ADMIN_URL}/login`;
    store.dispatch('FedLogOut').then(() => {
      window.location.href = loginUrl;
    });
  } 
  
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    Message({
      message: message,
      type: 'error'
    });
    return Promise.reject(new Error(message))
  }
  return res;
}, error => {
  // loadingInstance.close();
  return Promise.reject(new Error(error));
})

export default axios;
